<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
            |
            | {{ restricao.cpf_cnpj || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeRazoSocialDoAutoado') }}:
            |
            | {{ restricao.nome_razo_social_do_autoado || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataAutuacao') }}:
            |
            | {{ restricao.data_autuacao || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.auto') }}:
            |
            | {{ restricao.auto || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tipoInfracao') }}:
            |
            | {{ restricao.tipo_infracao || '-' }}
            br

            Criticidade(v-if='restricao.nivelAlerta', :restricao='restricao')
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'auto-infracao-to',

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        formatDocumento(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        }
    }
};
</script>
